module.exports = __webpack_public_path__ + "img/social_responsibility_book_shop.57afdd17.jpg";